import { rj, useRj, useRunRj } from "react-rocketjump"
import rjList, {
  nextPreviousPaginationAdapter,
} from "react-rocketjump/plugins/list"
import rjDebounce from "react-rocketjump/plugins/debounce"
import api from "../api"

const billingTrancheRj = rj(
  rjDebounce(),
  rjList({
    pageSize: 100,
    pagination: nextPreviousPaginationAdapter,
  }),
  {
    name: "bills",
    effectCaller: rj.configured(),
    effect: (wpAuth) => (params = {}) =>
      api.auth(wpAuth).get(`/api/bill`, params),
    mutations: {
      create: rj.mutation.single({
        effect: (wpAuth) => (data) => {
          return api.auth(wpAuth).post(`/api/bill`, data)
        },
        updater: (state, result) => {
          if (state?.data?.list) {
            return {
              ...state,
              data: {
                ...state.data,
                list: [...state.data.list, result],
              },
            }
          } else {
            return state
          }
        },
      }),
      update: rj.mutation.single({
        effect: (wpAuth) => (id, data) => {
          return api.auth(wpAuth).patch(`/api/bill/${id}`, data)
        },
        updater: (state, result) => {
          return {
            ...state,
            data: {
              ...state.data,
              list: state.data.list.map((item) =>
                item.id !== result.id ? item : result
              ),
            },
          }
        },
      }),
      remove: rj.mutation.single({
        effect: (wpAuth) => (itemId) => {
          return api
            .auth(wpAuth)
            .mapResponse(() => itemId)
            .delete(`/api/bill/${itemId}`)
        },
        updater: (state, result) => {
          if (state?.data?.list) {
            return {
              ...state,
              data: {
                ...state.data,
                list: state.data.list.filter((item) => item.id !== result),
              },
            }
          } else {
            return state
          }
        },
      }),
    },
    computed: {
      bills: "getList",
      count: "getCount",
      loading: "isPending",
      error: "getError",
      pageCount: "getNumPages",
      hasNext: "hasNext",
      hasPrev: "hasPrev",
    },
  }
)

export function useBills(params) {
  return useRunRj(billingTrancheRj, [params], false)
}

function useBillsControlled() {
  return useRj(billingTrancheRj)
}

useBills.controlled = useBillsControlled
